import React, { useEffect, useState } from 'react'
import { RotatingLines } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom'

const Topbar = (props) => {

    const book = props.book;
    const page = props.page;
    const title = props.title;
    const state = { state: { book: book } };
    const back = props.back;
    const isLoading = props.isLoading !== undefined ? props.isLoading : false;

    const navigate = useNavigate();

    useEffect(()=>{
        console.log(isLoading)
    })

    const renderHome = () => {
        if (page !== 'home') {
            return (
                <button className='is-pulled-left pt-1 pr-2' onClick={() => back()}>
                    <span className='icon'>
                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                    </span>
                </button>
            )
        }
    }

    const renderElement = () => {
        switch (page) {
            case 'login':
                return (
                    <div className='is-clearfix'>
                        <p className='is-size-5 is-pulled-left'>Bukukas</p>
                    </div>
                )
            case 'reset':
            case 'register':
            case 'verify':
                return (
                    <div className='is-clearfix'>
                        <button className='is-pulled-left pt-1 pr-2' onClick={() => navigate(-1)}>
                            <span className='icon'>
                                <i className="fa fa-chevron-left" aria-hidden="true"></i>
                            </span>
                        </button>
                        <p className='is-size-5 is-pulled-left'>Bukukas</p>
                    </div>
                )
            case 'home':
                return (
                    <div className='is-clearfix'>
                        <p className='is-size-5 is-pulled-left'>{title}</p>
                        <button className='is-pulled-right pt-1 pr-2 pl-2' onClick={() => navigate('/profile')}>
                            <i className="fa fa-user ml-2"></i>
                        </button>
                        <div className='is-pulled-right pt-1 pr-2 pl-2'>
                            <RotatingLines
                                visible={isLoading}
                                height="20"
                                width="20"
                                strokeColor="white"
                                strokeWidth="5"
                                animationDuration="0.75"
                                ariaLabel="rotating-lines-loading"
                            />
                        </div>
                    </div>
                );
            default:
                return (
                    <div className='is-clearfix'>
                        <button className='is-pulled-left pt-1 pr-2' onClick={() => back()}>
                            <span className='icon'>
                                <i className="fa fa-chevron-left" aria-hidden="true"></i>
                            </span>
                        </button>
                        <p className='is-size-5 is-pulled-left'>{title}</p>
                        <button className='is-pulled-right pt-1 pr-2 pl-2' onClick={() => navigate('/profile')}>
                            <i className="fa fa-user ml-2"></i>
                        </button>
                        <div className='is-pulled-right pt-1 pr-2 pl-2'>
                            <RotatingLines
                                visible={isLoading}
                                height="20"
                                width="20"
                                strokeColor="white"
                                strokeWidth="5"
                                animationDuration="0.75"
                                ariaLabel="rotating-lines-loading"
                            />
                        </div>
                    </div>
                )
        }
    }

    const styleTopBar = {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1,
    }

    return (
        <div className='container is-max-widescreen mb-6'>
            <nav style={styleTopBar} className='has-background-primary-15 has-text-white'>
                <div className='mb-0 pl-5 pr-5 pt-3 pb-3 '>
                    {renderElement()}
                </div>
            </nav>
        </div>
    )
}

export default Topbar
